import React from "react";
import { map, times } from "lodash";
import { Row } from "@/shared/ui/Blocks";
import { Skeleton } from "@/shared/ui/Skeleton";

function Loader({ loading = false }) {
  if (!loading) return null;
  return (
    <>
      {times(4, (index) => (
        <Skeleton key={index} className="w-full h-[230px] p-4 flex flex-col">
          <Skeleton className="w-[36px] h-[35px] rounded-full bg-grey-200" />
          <Skeleton className="w-2/3 h-4 mt-4 bg-grey-200" />
          <Skeleton className="w-3/4 h-2 mt-4 bg-grey-200" />
          <Skeleton className="w-3/5 h-2 mt-4 bg-grey-200" />
        </Skeleton>
      ))}
    </>
  );
}

interface CardGridProps<T> {
  data: T[];
  loading?: boolean;
  renderCard: (item: T) => React.ReactNode;
}

function CardGrid<T extends {}>(props: CardGridProps<T>) {
  const { data, loading, renderCard } = props;
  return (
    <Row className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
      {map(data, (item) => renderCard(item))}
      {loading && !data.length && <Loader loading={loading} />}
    </Row>
  );
}

export { CardGrid };
